__turbopack_context__.v({
  "divider": "Divider-module-scss-module__AzJCpq__divider",
});
